import { Feature } from 'ol';
import { MultiPoint, Polygon } from 'ol/geom';
import { Circle, Fill, Icon, Stroke, Style, Text } from 'ol/style';
import CircleStyle from 'ol/style/Circle';

import {
  addPinSvg,
  buildingCircle,
  buildingPin,
  churchCircle,
  churchPin,
  crownCircle,
  crownPin,
  hourglassCircleSvg,
  hourglassPinSvg,
  inventeringCircle,
  penCircleSvg,
  penPinSvg
} from './icons';

export enum Colors {
  RAA_ORANGE = '#C94A18',
  RAA_GRAY_2 = '#F4F4F4',
  RAA_GRAY_5 = '#6A6A6A',
  RAA_BLUE = '#00567E',
  RAA_BLUE_HOVER = '#004C6F',
  RAA_HIGHLIGHT_YELLOW = '#ffb219',
  TURQUOISE = '#00FFEC',
  TURQUOISE_HOVER = '#00E5D4',
  TURQUOISE_OPACITY_HOVER = 'rgba(0,229,212,0.5)',
  TURQUOISE_OPACITY = 'rgb(0, 255, 236, .2)',
  BLACK = '#000000',
  LIGHT_BLUE_OPACITY = 'rgb(0, 86, 126, .3)',
  WHITE = '#FFFFFF',
  GREEN = '#75FF00'
}

const circleRadius = 10;

const stroke = (color: string, width: number, lineDash?: Array<number>) =>
  new Stroke({
    color,
    width,
    lineDash
  });

const fill = (color: string) =>
  new Fill({
    color
  });

export const buildingPinTurquoise = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(buildingPin(Colors.TURQUOISE, Colors.RAA_BLUE)),
    anchor: [0.5, 1],
    scale: 1
  })
});

export const buildingPinTurquoiseHover = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(buildingPin(Colors.TURQUOISE_HOVER, Colors.RAA_BLUE_HOVER)),
    anchor: [0.5, 1],
    scale: 1
  })
});

export const buildingCircleTurquoise = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(buildingCircle(Colors.TURQUOISE, Colors.RAA_BLUE)),
    scale: 1
  })
});

export const buildingCircleTurquoiseHover = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(buildingCircle(Colors.TURQUOISE_HOVER, Colors.RAA_BLUE_HOVER)),
    scale: 1
  })
});

export const churchCircleTurquoise = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(churchCircle(Colors.TURQUOISE, Colors.RAA_BLUE)),
    scale: 1
  })
});

export const churchCircleTurquoiseHover = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(churchCircle(Colors.TURQUOISE_HOVER, Colors.RAA_BLUE_HOVER)),
    scale: 1
  })
});

export const churchPinTurquoise = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(churchPin(Colors.TURQUOISE, Colors.RAA_BLUE)),
    anchor: [0.5, 1],
    scale: 1
  })
});

export const churchPinTurquoiseHover = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(churchPin(Colors.TURQUOISE_HOVER, Colors.RAA_BLUE_HOVER)),
    anchor: [0.5, 1],
    scale: 1
  })
});

export const crownCircleTurquoise = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(crownCircle(Colors.TURQUOISE, Colors.RAA_BLUE)),
    scale: 1
  })
});

export const crownCircleTurquoiseHover = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(crownCircle(Colors.TURQUOISE_HOVER, Colors.RAA_BLUE_HOVER)),
    scale: 1
  })
});

export const crownPinTurquoise = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(crownPin(Colors.TURQUOISE, Colors.RAA_BLUE)),
    anchor: [0.5, 1],
    scale: 1
  })
});

export const crownPinTurquoiseHover = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(crownPin(Colors.TURQUOISE_HOVER, Colors.RAA_BLUE_HOVER)),
    anchor: [0.5, 1],
    scale: 1
  })
});

export const utkastCircle = new Style({
  image: new Circle({
    fill: fill(Colors.RAA_ORANGE),
    radius: 6,
    displacement: [10, 44]
  })
});

export const hourglassPinTurquoise = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(hourglassPinSvg(Colors.TURQUOISE)),
    anchor: [0.5, 1],
    scale: 1
  })
});

export const hourglassCircleHover = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(hourglassCircleSvg(Colors.TURQUOISE_HOVER)),
    scale: 1
  })
});

export const hourglassCircleTurquoise = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(hourglassCircleSvg(Colors.TURQUOISE)),
    scale: 1
  })
});

export const hourglassPinHover = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(hourglassPinSvg(Colors.TURQUOISE_HOVER)),
    anchor: [0.5, 1],
    scale: 1
  })
});

export const penPinTurquoise = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(penPinSvg(Colors.TURQUOISE, Colors.RAA_BLUE)),
    anchor: [0.5, 1],
    scale: 1
  })
});

export const penCircleHover = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(penCircleSvg(Colors.TURQUOISE_HOVER, Colors.RAA_BLUE)),
    scale: 1
  })
});

export const penCircleTurquoise = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(penCircleSvg(Colors.TURQUOISE)),
    scale: 1
  })
});

export const penPinHover = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(penPinSvg(Colors.TURQUOISE_HOVER)),
    anchor: [0.5, 1],
    scale: 1
  })
});

export const addPinRaaGray5 = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(addPinSvg()),
    anchor: [0.5, 1],
    scale: 1,
    displacement: [5, 0]
  })
});

export const addPinRaaGray5Hover = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(addPinSvg(Colors.RAA_GRAY_2, Colors.RAA_GRAY_5)),
    anchor: [0.5, 1],
    scale: 1,
    displacement: [5, 0]
  })
});

export const inventeringPinTurquoiseStyle = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(inventeringCircle(Colors.TURQUOISE, Colors.RAA_BLUE)),
    scale: 1
  })
});

export const inventeringPinTurquoiseHoverStyle = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(inventeringCircle(Colors.TURQUOISE_HOVER, Colors.RAA_BLUE)),
    scale: 1
  })
});

export const inventeringCircleBlueStyle = new Style({
  image: new Icon({
    src: 'data:image/svg+xml,' + encodeURIComponent(inventeringCircle(Colors.RAA_BLUE, Colors.WHITE)),
    scale: 1
  })
});

export const selectedByggnadsPolygonHoverStyle = new Style({
  stroke: stroke(Colors.BLACK, 4, [6, 3])
});

export const templatePolygonHoverStyle = new Style({
  stroke: stroke(Colors.RAA_BLUE, 2)
});

export const selectedByggnadsPolygonStyle = new Style({
  stroke: stroke(Colors.BLACK, 2, [6, 3])
});

export const activeInventeringsytaStyle = new Style({
  fill: fill(Colors.TURQUOISE_OPACITY),
  stroke: stroke(Colors.RAA_BLUE, 2, [6, 3])
});

export const activeInventeringsytaHoverStyle = new Style({
  fill: fill(Colors.TURQUOISE_OPACITY_HOVER),
  stroke: stroke(Colors.RAA_BLUE, 2, [6, 3])
});

export const selectedByggnadsutkastYtaStyle = new Style({
  fill: fill(Colors.TURQUOISE_OPACITY),
  stroke: stroke(Colors.RAA_BLUE, 2)
});

export const selectedByggnadsutkastYtaHoverStyle = new Style({
  fill: fill(Colors.TURQUOISE_OPACITY_HOVER),
  stroke: stroke(Colors.RAA_BLUE_HOVER, 2)
});

export const drawPolygonStyle = new Style({
  stroke: stroke(Colors.RAA_BLUE, 2, [6, 3]),
  fill: fill(Colors.LIGHT_BLUE_OPACITY)
});

export const modifyCircleStyle = new Style({
  image: new CircleStyle({
    radius: circleRadius,
    fill: fill(Colors.RAA_BLUE),
    stroke: stroke(Colors.RAA_BLUE, 3)
  })
});

export const drawPolygonPointsStyle = new Style({
  image: new CircleStyle({
    radius: circleRadius,
    stroke: stroke(Colors.RAA_BLUE, 2),
    fill: fill(Colors.WHITE)
  }),
  geometry: (feature) => {
    const polygon = feature.getGeometry() as Polygon;
    if (polygon) {
      const coordinates = polygon.getCoordinates()[0];
      return new MultiPoint(coordinates);
    }
  }
});

interface Styles {
  Polygon: Style[];
  LineString: Style[];
}

export const getDefaultStyleFunction = (): any => {
  const styles = {
    Polygon: [
      new Style({
        fill: fill(Colors.LIGHT_BLUE_OPACITY)
      })
    ],
    LineString: [
      new Style({
        stroke: stroke(Colors.RAA_BLUE, 3)
      })
    ],
    Point: [
      new Style({
        image: new CircleStyle({
          radius: 10,
          fill: new Fill({
            color: Colors.RAA_BLUE
          }),
          stroke: new Stroke({
            color: Colors.RAA_BLUE,
            width: 2
          })
        }),
        zIndex: Infinity
      })
    ]
  };

  return (feature: Feature) => {
    const type = feature.getGeometry()?.getType();

    if (type !== 'Polygon' && type !== 'LineString' && type !== 'Point') {
      return;
    }

    return styles[type as keyof Styles];
  };
};

export const deleteVertexStyle = [
  new Style({
    text: new Text({
      text: '-',
      font: 'normal 28px Georgia',
      fill: fill(Colors.WHITE),
      offsetY: -1
    }),
    geometry: (feature) => {
      if (feature.getGeometry()?.getType() === 'Polygon') {
        const polygon = feature.getGeometry() as Polygon;
        if (polygon) {
          const coordinates = polygon.getCoordinates()[0];
          return new MultiPoint(coordinates);
        }
      }
    }
  }),
  new Style({
    image: new CircleStyle({
      radius: circleRadius,
      fill: fill(Colors.RAA_ORANGE)
    }),
    geometry: (feature) => {
      if (feature.getGeometry()?.getType() === 'Polygon') {
        const polygon = feature.getGeometry() as Polygon;
        if (polygon) {
          const coordinates = polygon.getCoordinates()[0];
          return new MultiPoint(coordinates);
        }
      }
    }
  })
];

export const drawDeletePolygonStyle = new Style({
  image: new CircleStyle({
    radius: circleRadius * 2,
    fill: fill(Colors.RAA_ORANGE)
  }),
  text: new Text({
    text: '\ue929',
    font: 'normal 18px raa-icons',
    scale: 1.5,
    textAlign: 'center',
    offsetY: 17,
    fill: fill(Colors.WHITE),
    textBaseline: 'bottom'
  })
});

export const drawDeleteStyle = [drawPolygonStyle, ...deleteVertexStyle];
